import * as React from "react";

function SvgLogout() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill='#284672 ' style={{ marginTop: '-2px' }}  viewBox="0 0 16 16">
            <g id="Icon_feather-log-out"  data-name="Icon feather-log-out" transform="translate(-3.5 -3.5)">
                <path id="Path_1" data-name="Path 1" d="M9.167,18.5H6.056A1.556,1.556,0,0,1,4.5,16.944V6.056A1.556,1.556,0,0,1,6.056,4.5H9.167" fill="none" stroke="#284672 " stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <path id="Path_2" data-name="Path 2" d="M24,18.278l3.889-3.889L24,10.5" transform="translate(-9.389 -2.889)" fill="none" stroke="#284672 " stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                <path id="Path_3" data-name="Path 3" d="M22.833,18H13.5" transform="translate(-4.333 -6.5)" fill="none" stroke="#284672 " stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
            </g>
        </svg>


    );
}
export default SvgLogout;


// WEBPACK FOOTER //
// ./src/iconComponents/logoutIcon.js